import { render } from "./PayoutSettingsPopup.vue?vue&type=template&id=31c10a8f&ts=true"
import script from "./PayoutSettingsPopup.vue?vue&type=script&lang=ts"
export * from "./PayoutSettingsPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__